import React from "react";
import { useTheme } from "../context/ThemeContext";

const Chips = ({ text }) => {
    const {theme} = useTheme();
  return text ? (
    <span className={`rounded-full px-2.5 py-1 text-[14px] font-medium h-[25px] ${theme ==='light'?'bg-gray-100 text-gray-700':'bg-gray-800 text-gray-300'}`}>
      {text}
    </span>
  ) : null;
};

export default Chips;
